/* eslint-disable no-useless-escape */
import React, { Fragment, useRef } from "react";
import PropTypes from "prop-types";
import { FormGroupInput } from "components/formElements";
import { minCTC, stepCTC } from "util/library";
import { getCompanyErrorMessage, getCTCErrorMessage } from "util/validations";

const CurrentCompany = ({
  handleChange,
  currentCompany,
  currentCompanyWebsite,
  currentCTC,
}) => {
  const inputRef = useRef(null);

  return (
    <Fragment>
      <FormGroupInput
        type="text"
        id="currentCompany"
        name="currentCompany"
        label="Current Company"
        //placeholder="Current Company"
        required
        value={currentCompany}
        onChange={handleChange}
        errorMessage={getCompanyErrorMessage(
          currentCompany,
          "Company name",
          true
        )}
        pattern={"[a-z|A-Z]{1}[a-z|A-Z|.&\\s]{1}(a-z|A-Z| |.)*"}
      />
      <FormGroupInput
        type="text"
        id="currentCompanyWebsite"
        name="currentCompanyWebsite"
        label="Current Company Website"
        //placeholder="Current Company Website"
        value={currentCompanyWebsite}
        onChange={handleChange}
        pattern="[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)"
        errorMessage="Company Website is not valid"
      />
      <FormGroupInput
        type="number"
        min={minCTC}
        step={stepCTC}
        id="currentCTC"
        name="currentCTC"
        label="Current Annual CTC(in LPA)"
        //placeholder="Current Annual CTC(in LPA)"
        value={currentCTC}
        onChange={handleChange}
        inputRef={inputRef}
        errorMessage={getCTCErrorMessage(inputRef, currentCTC)}
      />
    </Fragment>
  );
};

CurrentCompany.propTypes = {
  handleChange: PropTypes.func.isRequired,
  currentCompany: PropTypes.string.isRequired,
  currentCompanyWebsite: PropTypes.string.isRequired,
  currentCTC: PropTypes.string.isRequired,
};

export { CurrentCompany };
